function server() {
    // return 'https://api.liberrex.tn/v1'
    // return 'http://localhost:8003/v1'
    if(process.env.VUE_APP_EDIT_HOST === "true" && localStorage.getItem('host') != null) {
        return localStorage.getItem('host');
    }
    else {
    switch (localStorage.getItem('Server')) {
        case 'tn': return process.env.VUE_APP_API_URL_TN;
        case 'ci': return process.env.VUE_APP_API_URL_CI;
        default: return process.env.VUE_APP_API_URL;
    }
}
}
export const ApiConfigs = {
    base_url: server() + '/admin' ,
    broadcast_url: server() + '/broadcasting',
    captcha_url: process.env.VUE_APP_CAPTCHA_URL,
    /* -------------------------------- */
    // PUSHER
    pusher: {
        auth: '/auth',
    },
    // ACCOUNT
    accounts: {
        login: '/account/auth',
        logout: '/account/logout',
        reset_password: '/account/password/reset',
        reset_update_password: '/account/password/reset/update',
        createaccount: '/account',
        captcha: process.env.VUE_APP_CAPTCHA_LINK,
    },
    //SMS
    sms: {
        getAll: '/sms',
        getPage: '/sms?pagination=10&page=',
        getByDateRange : '/sms/range'
    },
    terms: {
        getTerms: '/terms',
        addTerms: '/terms/set'
    },
    // policy
    policy: {
        getPolicy: '/policy',
        addPolicy: '/policy/set'
    },
    //pings
    pings: {
        getKioskPings : '/kiosks/pings' , 
        getDisplayPings : '/displays/pings',
        getById:'/kiosks/pings/:id',
        DisplaygetById:'/displays/pings/:id',
        getDownDisplays:'/displays/pings/down',
        getDownKiosk:'/kiosks/pings/down'




    },
    // SERVICES
    services: {
        getAll: '/services',
        update: '/services/:id/update',
        create: '/services/create',
        translate: '/services/translate',
        getById: '/services/:id',
        getPage: '/services?pagination=10&page=',
        search: '/services/filter/:keyword',
        delete: '/services/:id/delete'
    },
    //INDUSTRY 
    industry: {
        getAll: '/industry',
        getByDateRange: '/sms/range',
        getsubindustries: '/industry/subindustry',
        create: '/industry/create',
        update: '/industry/:id/update',
        delete: '/industry/:id/delete',
        filter: '/industry/filter'

    },

    // Region 
    region: {
        getZoneWithStates: '/zone',
        getZoneWithStatesById: '/zone/:zone_id',
        getsubindustries: '/industry/subindustry',
        create: '/zone/create',
        update: '/zone/:zone_id/update',
        updateState: '/state/:state_id/update',
        delete: '/zone/:zone_id/delete',
        addState: '/state/create',
        deleteState: '/state/:state_id/delete'
    },

    subindustry: {
        getAll: '/subindustry',
        update: '/subindustry/:id/update',
        delete: '/subindustry/:id/delete',
        create: '/subindustry/create'
    },
    //TEAM
    team: {
        addTeamMember: '/account',
        getById: '/account/:id',
        delete: '/account/:id',
        update: '/account/:id',
        getAll: '/account',
        getPage: '/account?pagination=10&page='

    },
    //Business
    business: {
        getAllApproved: '/business?approved=1',
        getApprovedBypage: '/business?approved=1&pagination=10&page=',
        getAllDisapproved: '/business?approved=0',
        getDisapprovedBypage: '/business?approved=0&pagination=10&page=',
        getAll: '/business',
        getAllMinified: '/business/getAllMinified',
        getPage: '/business?append=rating&pagination=10&page=',
        getById: '/business/:id',
        update: '/business/:id',
        createBusiness: '/business/create',
        createUser: '/user/create',
        deleteBusiness: '/business/:id',
        ApprovedBusiness: '/business/:id/approve',
        DisapprovedBusiness: '/business/:id/disapprove',
        getBusinessByOrganization: '/business/:id/organization',
        updatePermissions: '/business/permissionUpdate',
        getAllRequests: '/user/business/requests',
        getCountAllRequests: '/user/business/requests/count',
        UpdateBusinessRequestApproval: '/user/business/requests/:id/update_approval',
        search: '/business/filter/:keyword?append=rating',
        getUserByBusinessID: '/users/:id',
        deleteUser: '/deleteUser/:id',
        getUserByID: '/getUserByID/:id',
        updateUser: '/updateUser/:id',
        filter: '/business/filter/:keyword?append=rating',
        getServices: "/business/:id/services"
    },

    //Packages
    packages: {
        getAll: '/packages',
        getPage: '/business?pagination=10&page=',
        getById: '/business/:id',
        deleteBusiness: '/business/:id',
        ApprovedBusiness: '/business/:id/approve',
        DisapprovedBusiness: '/business/:id/disapprove'
    },
    // HELPERS
    helpers: {
        getAdsllServices: '/helpers/service?pagination=1000',
        filterServices: '/helpers/setting/filter/:keyword',
        getIndustries: '/industry',
        getOrganizations: '/organization',
        getCountries: '/countries'
    },

    //ORGANIZATION 
    organization: {
        getAll: '/organization',
        create: '/organization',
        getById: '/organization/:id',
        update: '/organization/:id',
        delete: '/organization/:id',
        getPage: '/organization?pagination=10&page=',
        search: '/organization/filter/:keyword',

    },

    // RESELLER
    reseller: {
        getAll: '/resellers',
        getById: '/reseller/:id',
        create: '/reseller/add',
        update: '/reseller/:id/update',
        refreshKey: '/reseller/:id/refresh',
        grantAccess: '/reseller/:id/access/add'
    },
    // payment methods
    paymentMethods: {
            getTypes: '/type-payment',
            addType: '/type-payment/create',
            updateType: '/type-payment/:id/update',
            deleteType: '/type-payment/:id/delete',
        },

    //MANAGER 
    manager: {
        getAll: '/manageraccount',
        create: '/manageraccount',
        getByOrganization: '/manageraccount/:id/organization',
        getPage: '/manageraccount/:id/organization?pagination=10&page=',
        delete: '/manageraccount/:id',
        update: '/manageraccount/:id'
    },
    //TICKET
    ticket: {
        getAll: '/ticketBackgroundImages',
        create: '/ticketBackgroundImages',
        delete: '/ticketBackgroundImages/:id'
    },
    //ADVERTISEMENT
    advertisement: {
        getAll: '/advertisement',
        create: '/advertisement',
        delete: '/advertisement/:id',
        update: '/advertisement/:id'
    },
    /* -------------------------------- */
    // STATISTICS
    statistics: {
        getAll: '/statistic',
        filter: '/statistic/filter',
        home: '/statistic/home',
        home_filter: '/statistic/home/filter',
        avgWatingService: '/statistic/AvgWatingService',
        visitFrequency: '/statistic/visiteFrequency',
        InclusiveVisitFrequency: '/statistic/InclusiveVisitFrequency',
        serviceFrequency: '/statistic/servicefrequency',
        customerStat: '/statistic/customerStat'
    },
    /* -------------------------------- */
    // MOBILE
    mobile: {
        getSettings: '/mobile/settings',
        updateSettings: '/mobile/settings/update'
    },
    // HARIF
    harif: {
        getAll: '/harif/gateways',
        getById: '/harif/gateways/:id',
        create: '/harif/gateways/create',
        update: '/harif/gateways/update/:id',
        delete: '/harif/gateways/delete/:id',
        filter: '/harif/gateways/filter'
    },

    //feedback 
    feedback: {
        getAll: '/feedback',
        getPage: '/feedback?pagination=10&page=',
        filter: '/feedback/filter',
        getById: '/feedback/:id',
        getPageFilter: '/feedback/filter?page=',
    },

    requestTT: {
        getAll: '/requestTT',
        getByParentId: '/requestTT/:id',
        markDelivered: '/requestTT/:id/mark-as-delivered'
    }
};
